__turbopack_context__.v({
  "disabled": "AppLink-module__cyWDwa__disabled",
  "highlight": "AppLink-module__cyWDwa__highlight",
  "main": "AppLink-module__cyWDwa__main",
});
